<template>
  <div class="right_col" role="main">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{ title }}
            <span v-if="isConfirmView"
              >- {{ $t('orderPage.inputConfirmation') }}</span
            >
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content form-horizontal form-label-left">
              <alert
                :title="title"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="alertDisplay"
                @closeAlert="closeAlert"
              />

              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12"
                  >{{ $t('common.implementationGroup') }}：
                  <span class="required">*</span></label
                >
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <textarea
                    id="shops"
                    v-model="inputShopValues"
                    v-validate="ValidRules.shops"
                    :data-vv-as="$t('common.implementationGroup')"
                    name="shops"
                    class="form-control"
                    rows="10"
                    style="resize: none"
                    readonly
                  >
                  </textarea>
                  <div class="clearfix"></div>
                  <div
                    v-show="validator.has('shops')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('shops')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12">
                  <button
                    id="add-shop-btn"
                    :disabled="isConfirmView"
                    @click="showModal('shop')"
                    class="btn btn-success"
                  >
                    {{ $t('common.edit') }}
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12"
                  >{{ $t('adPage.implementationTimingConditions') }}：
                  <span class="required">*</span></label
                >
                <div class="col-md-3 col-sm-3 col-xs-4">
                  <select
                    id="timing"
                    ref="timing"
                    v-model="timing"
                    :disabled="isConfirmView"
                    name="timing"
                    class="form-control"
                  >
                    <option value="0">
                      {{ $t('adPage.fromTheFirstOrder') }}
                    </option>
                    <option value="1">
                      {{ $t('adPage.fromTheLastOrder') }}
                    </option>
                    <option value="2">
                      {{ $t('adPage.immediatelyAfterAuthentication') }}
                    </option>
                  </select>
                </div>
                <div v-show="timing < 2" class="col-md-1 col-sm-1 col-xs-2">
                  <input
                    id="elapsedAt"
                    v-model="elapsedAt"
                    v-validate="ValidRules.elapsedAt"
                    :disabled="isConfirmView"
                    :data-vv-as="$t('adPage.elapsedTime')"
                    :placeholder="$t('adPage.elapsedTime')"
                    type="number"
                    min="1"
                    max="60"
                    name="elapsedAt"
                    class="form-control"
                  />
                </div>
                <div
                  v-show="timing < 2"
                  class="col-md-1"
                  style="padding-left: 0"
                >
                  <label class="control-label" for="elapsedAt">{{
                    $t('adPage.minutesLater')
                  }}</label>
                </div>
                <div class="clearfix"></div>
                <div
                  v-show="validator.has('elapsedAt')"
                  class="col-md-offset-3 col-md-5"
                >
                  <div class="alert alert-danger" role="validater">
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'elapsedAt'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12"
                  >{{ $t('adPage.timedRecommendImage') }}：
                  <span v-if="!isEdit" class="required">*</span></label
                >
                <div class="col-md-3 col-sm-3 col-xs-4">
                  <input
                    v-model="selectedImageName"
                    :class="{ 'is-invalid': validator.has('image') }"
                    type="text"
                    name="imageName"
                    class="form-control"
                    readonly
                  />
                  <p>
                    {{ $t('adPage.imageUploadDescription') }}
                  </p>
                </div>
                <div class="col-md-2 col-sm-2 col-xs-2">
                  <label
                    :disabled="isConfirmView"
                    for="image"
                    class="btn btn-success margin-20"
                  >
                    <input
                      id="image"
                      v-validate="getImageValidateRule()"
                      :data-vv-as="$t('adPage.timedRecommendImage')"
                      :disabled="isConfirmView"
                      @change="onDrop"
                      type="file"
                      class="drop__input"
                      style="display: none"
                      name="image"
                    />
                    {{ $t('common.import') }}
                  </label>
                  <button
                    v-if="selectedImageData"
                    @click="toggleModal()"
                    class="btn btn-warning"
                  >
                    {{ $t('common.display') }}
                  </button>
                </div>
                <div class="clearfix"></div>
                <div
                  v-show="validator.has('image')"
                  class="col-md-offset-3 col-md-5"
                >
                  <div class="alert alert-danger" role="validater">
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('image')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3 col-xs-12"
                  >{{ $t('common.recommendMenu') }}：
                  <span class="required">*</span></label
                >
                <div class="col-md-5 col-sm-5 col-xs-12">
                  <textarea
                    id="recommend"
                    v-model="inputRecommendValues"
                    v-validate="ValidRules.recommend"
                    :data-vv-as="$t('common.recommendMenu')"
                    name="recommend"
                    class="form-control"
                    rows="10"
                    style="resize: none"
                    readonly
                  >
                  </textarea>
                  <div class="clearfix"></div>
                  <div
                    v-show="validator.has('recommend')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'recommend'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4 col-sm-3 col-xs-12">
                  <button
                    id="add-item-btn"
                    :disabled="isConfirmView"
                    @click="showModal('recommend')"
                    class="btn btn-success"
                  >
                    {{ $t('common.edit') }}
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-md-3 col-sm-3" for="startAt"
                  >{{ $t('adPage.recommendPeriod') }}
                  <template v-if="!isJp">({{ timezone }})</template>：
                  <span class="required">*</span></label
                >
                <div class="col-md-5 col-sm-6 col-xs-12">
                  <strong>
                    <input
                      id="startAt"
                      ref="startAt"
                      v-model="displayStartAt"
                      v-validate="ValidRules.startAt"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('adPage.recommendPeriodStart')"
                      type="date"
                      name="startAt"
                    />
                  </strong>
                  <label style="margin-left: 10px" for="endAt"
                    >{{ $t('eventInformationPage.endDate') }}：</label
                  >
                  <strong>
                    <input
                      id="endAt"
                      ref="endAt"
                      v-model="displayEndAt"
                      v-validate="ValidRules.endAt"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('adPage.recommendPeriodEnd')"
                      type="date"
                      name="endAt"
                    />
                  </strong>
                  <div
                    v-show="validator.has('startAt') || validator.has('endAt')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('startAt')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('endAt')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="ln_solid"></div>
              <div class="form-group">
                <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                  <button
                    @click="back"
                    class="btn btn-default"
                    to="/ad/timedrecommend"
                  >
                    {{ $t('common.back') }}
                  </button>
                  <button
                    v-if="!isConfirmView"
                    @click="confirm"
                    class="btn btn-success"
                  >
                    {{ $t('common.inputComplete') }}
                  </button>
                  <button v-else @click="submit" class="btn btn-success">
                    {{ $t('orderPage.registration') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      :class="{ 'is-open': isModalActive }"
      @click="toggleModal()"
      class="p-modal"
    >
      <img :src="selectedImageData" />
    </div>
    <modal
      v-if="isShowModal"
      :current="current"
      :list-items="listItems"
      @close="isShowModal = false"
      @valueInput="valueInput"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import { getServerDateTime, getTimezone } from '@/utility/time'
import alert from '@/mixin/alert'

import Alert from '@/components/common/alert/Alert'
import Modal from '@/components/common/modal/AdRegistModal'
import TimeRecommendRequest from '@/http/TimeRecommendRequest'
import ValidRules from '@/validator/TimerRecommendRules'

export default {
  components: {
    Alert,
    Modal,
  },
  mixins: [alert],
  data() {
    return {
      title: this.$t('adPage.timedRecommendRegistration'),
      displayStartAt: '',
      displayEndAt: '',
      timing: 0,
      elapsedAt: null,
      isEdit: false,
      isConfirmView: false,
      current: String,
      isShowModal: false,
      isModalActive: false,
      inputShopValues: '', // 選択済みグループの名前の羅列
      inputRecommendValues: '', // 選択済みレコメンドメニューの名前の羅列
      selectedImageName: '', // この画面で選択された画像のファイル名。表示用
      selectedImageData: '', // この画面で選択された画像の base64 文字列
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      getTimeRecommendById: 'timeRecommend/getTimeRecommendById',
      getGroups: 'shop/getGroupToShops',
      getItems: 'item/getItems',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    timeRecommend() {
      return this.getTimeRecommendById(this.$route.params.id)
    },
    timezone() {
      return getTimezone()
    },
  },
  mounted() {
    this.createItemData()
    this.createGroupData()

    if (this.$route.name === 'timerRecommendFormEdit') {
      this.getStoreData(this.$route.params.id)
      this.isEdit = true
      this.title = this.$t('adPage.editTimedRecommend')
    }
  },
  methods: {
    // 画像アップロートのバリデーション
    getImageValidateRule: function() {
      return this.isEdit ? ValidRules.image.edit : ValidRules.image.create
    },
    // レコメンドメニューの作成
    createItemData: function() {
      const data = this.getItems
      this.recommendItemDatas = data.list.map((item) => {
        let toppingItem = ''
        Object.values(item.toppings).forEach((topping) => {
          toppingItem += topping
        })
        return [
          {
            type: 'checkbox',
            id: item.itemCode,
            checked: false,
            target: 'recomend',
          },
          item.itemCode,
          item.names[this.language],
          item.itemKind.name,
          toppingItem,
        ]
      })
    },

    // 実施グループの作成
    createGroupData: function() {
      const data = this.getGroups
      this.allGroupDatas = data.map((item) => {
        const names = item.shops.map((shop) => {
          return shop.name
        })
        const body = names.join('　')

        return [
          {
            type: 'checkbox',
            id: item.groupId,
            checked: false,
            target: 'shop',
          },
          item.groupId,
          { type: 'accordion', id: item.groupId, title: item.name, body: body },
        ]
      })
    },
    getStoreData: function() {
      // 実施グループ
      let groupNameList = []
      this.timeRecommend.groupList.forEach((item) => {
        const index = this.allGroupDatas.findIndex(
          (group) => group[1] === item.groupId
        )
        if (index > -1) {
          this.allGroupDatas[index][0].checked = true
          groupNameList.push(item.name)
        }
      })
      this.inputShopValues = groupNameList.join('\n')

      // レコメンドメニュー
      let recommendNameList = []
      this.timeRecommend.recommendList.forEach((item) => {
        const index = this.recommendItemDatas.findIndex(
          (recommend) => recommend[1] === item.itemCode
        )
        if (index > -1) {
          this.recommendItemDatas[index][0].checked = true
          recommendNameList.push(item.name)
        }
      })
      this.inputRecommendValues = recommendNameList.join('\n')

      // 表示タイミング
      this.timing = this.timeRecommend.timing
      this.elapsedAt =
        this.timeRecommend.elapsedAt === 0 ? null : this.timeRecommend.elapsedAt

      // 日付
      this.displayStartAt = getServerDateTime(
        this.timeRecommend.displayStartAt
      ).format('YYYY-MM-DD')
      this.displayEndAt = getServerDateTime(
        this.timeRecommend.displayEndAt
      ).format('YYYY-MM-DD')

      // 画像
      this.selectedImageData = this.timeRecommend.recommendImage
    },
    back: function() {
      if (this.isConfirmView) {
        this.isConfirmView = false
      } else {
        this.$router.push({ name: 'timerRecommend' })
      }
    },
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    submit: function() {
      let groupIds = []
      this.allGroupDatas.forEach((item) => {
        if (item[0].checked) {
          groupIds.push(item[1])
        }
      })

      let recommendItemCodes = []
      this.recommendItemDatas.forEach((item) => {
        if (item[0].checked) {
          recommendItemCodes.push(item[1])
        }
      })

      const request = new TimeRecommendRequest()
      const params = {
        timing: Number(this.timing),
        groupIds: groupIds,
        recommendItemCodes: recommendItemCodes,
        recommendImage: this.selectedImageData,
        displayStartAt: global
          .moment(this.displayStartAt)
          .format('YYYY-MM-DD 00:00:00'),
        displayEndAt: global
          .moment(this.displayEndAt)
          .format('YYYY-MM-DD 23:59:59'),
      }

      if (this.timing < 2) {
        params['elapsedAt'] = Number(this.elapsedAt)
      }

      if (this.isEdit) {
        // 更新
        request
          .update(this.$route.params.id, params)
          .then(() => {
            this.$router.push({
              name: 'timerRecommend',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      } else {
        // 新規登録
        request
          .insert(params)
          .then(() => {
            this.$router.push({
              name: 'timerRecommend',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      }
    },
    valueInput: function(inputValues) {
      switch (this.current) {
        case 'shop':
          this.inputShopValues = inputValues.join('\n')
          break
        case 'recommend':
          this.inputRecommendValues = inputValues.join('\n')
          break
        default:
          break
      }
      this.isShowModal = false
    },
    showModal: function(current) {
      this.current = current
      switch (this.current) {
        case 'shop':
          this.listItems = this.allGroupDatas
          break
        case 'recommend':
          this.listItems = this.recommendItemDatas
          break
        default:
          break
      }
      this.isShowModal = true
    },
    // 画像ファイルの選択
    onDrop: function(event) {
      const file = event.target.files[0]

      if (file === undefined) {
        this.selectedImageName = ''
        this.selectedImageData = ''
        return
      }

      this.selectedImageName = file.name
      this.$validator.validate('image').then((result) => {
        if (result) {
          this.encode(file)
        } else {
          this.selectedImageData = ''
        }
      })
    },
    // エンコード
    encode: function(file) {
      const blob = new Blob([file], { type: file.type })
      const reader = new FileReader()

      // 描画する（画面には表示されない)
      reader.readAsDataURL(blob)

      // 描画が終わると base64 に encode して post 用のデータとしてセット
      reader.onload = () => {
        return new Promise((resolve) => {
          const base64 = reader.result
          resolve(base64)
        }).then((base64) => {
          this.selectedImageData = base64
        })
      }
    },
    // モーダル表示非表示の切り替え
    toggleModal() {
      this.isModalActive = !this.isModalActive
    },
  },
}
</script>
<style scoped>
.checker .check {
  display: inline-block;
  vertical-align: middle;
}
.checker .text {
  display: inline-block;
  vertical-align: middle;
  max-width: 80px;
}
.checker input {
  display: none;
}
.checker .check {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.checker.disabled,
.checker.disabled .check::before {
  cursor: not-allowed;
}
.checker.disabled .check::before {
  opacity: 0.65;
}
.checker .check::before {
  display: block;
  position: absolute;
  top: 1px;
  left: 0;
  width: 22px;
  height: 22px;
  border: 1px solid #169f85;
  content: '';
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #26b99a;
  border-radius: 3px;
}
.checker input:checked + .check::after {
  display: block;
  position: absolute;
  top: 5px;
  left: 3px;
  width: 16px;
  height: 8px;
  border-left: 3px solid #fff;
  border-bottom: 3px solid #fff;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  content: '';
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
